import { ArrowRight, FolderKanban, LayoutGrid, Settings2 } from "lucide-react";
import type { ComponentType } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import type { DashboardWidget } from "@/types/api";

/** Icona per rotta (fallback generico). */
const ROUTE_ICON: Record<string, ComponentType<{ className?: string }>> = {
  "/progetto": FolderKanban,
  "/admin": Settings2,
};

interface PortaConfig {
  route?: string;
  label?: string;
}

/**
 * Widget «porta» (SPEC-A §5.3): card orizzontale che fa da gateway verso una
 * pagina (vetrina di progetto, backoffice). La visibilità è governata da RBAC
 * come ogni widget.
 */
export function WidgetPorta({ widget }: { widget: DashboardWidget }) {
  const navigate = useNavigate();
  const config = (widget.config ?? {}) as PortaConfig;
  const route = config.route ?? "/";
  const Icon = ROUTE_ICON[route] ?? LayoutGrid;

  return (
    <section className="flex items-center gap-4 rounded-xl border bg-card/60 p-5">
      <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-brand-50 text-brand-700">
        <Icon className="size-5" aria-hidden="true" />
      </div>
      <div className="min-w-0 flex-1">
        <h2 className="text-sm font-semibold tracking-tight">{widget.titolo}</h2>
        {widget.descrizione && (
          <p className="text-xs text-muted-foreground">{widget.descrizione}</p>
        )}
      </div>
      <Button size="sm" variant="outline" onClick={() => navigate(route)}>
        {config.label ?? "Apri"}
        <ArrowRight className="size-4" />
      </Button>
    </section>
  );
}
